import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { editRefundPolicy, getRefundPolicy } from "../../redux/services/informationSlice";
import Information from "../../common/information";
import { toast } from "react-toastify";

const RefundPolicy = () => {
  const dispatch = useDispatch();
  const [editorContent, setEditorContent] = useState("");
  const [selectedType, setSelectedType] = useState("course");

  const refundPolicyData = useSelector((state) => state?.information?.refundPolicyData);

  const handleEditorChange = (newContent) => {
    setEditorContent(newContent);
  };

  // Fetch refund policy data
  const getRefundPolicyData = useCallback(
    async (type) => {
      try {
        await dispatch(getRefundPolicy(type));
      } catch (error) {
        console.error("Error fetching refund policy:", error);
      }
    },
    [dispatch]
  );

  useEffect(() => {
    getRefundPolicyData(selectedType);
  }, [getRefundPolicyData, selectedType]);

  // Submit refund policy changes
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await dispatch(
        editRefundPolicy({ refundPolicy: editorContent, type: selectedType })
      );
      if (response) {
        toast.success(response?.payload?.message, {
          autoClose: 2000,
          pauseOnHover: false,
        });
        getRefundPolicyData(selectedType);
      }
    } catch (error) {
      console.error("Error updating refund policy:", error);
    }
  };

  // Update editor when redux data changes
  useEffect(() => {
    if (refundPolicyData) {
      setEditorContent(refundPolicyData?.refundPolicy);
    }
  }, [refundPolicyData]);

  return (
    <>
      <Information
        title="Refund Policy"
        handleSubmit={handleSubmit}
        editorContent={editorContent}
        handleEditorChange={handleEditorChange}
        selectedType={selectedType}
        setSelectedType={setSelectedType}
      />
    </>
  );
};

export default RefundPolicy;
